import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbMarkCircle: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 24, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} {...props}>
      <g id='Box'>
        <rect fill='none' width={size} height={size} />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <path fill={fill} d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1ZM10,18,5,13l1.5-1.49L10,15l7.5-7.49L19,9Z' />
      </g>
    </svg>
  );
};
